var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 5.62508L9.46637 9.61696C9.78741 9.84745 10.2126 9.84745 10.5336 9.61696L16.0938 5.62508M4.375 15.8334H15.625C16.6605 15.8334 17.5 14.9629 17.5 13.889V6.11119C17.5 5.03731 16.6605 4.16675 15.625 4.16675H4.375C3.33947 4.16675 2.5 5.03731 2.5 6.11119V13.889C2.5 14.9629 3.33947 15.8334 4.375 15.8334Z",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.95ce9035927c905f64ca0f9a83f778af.svg";
export { ForwardRef as ReactComponent };